import { BulkExportActivityType } from './types';

export function getDialogTitle(activityType: BulkExportActivityType) {
  switch (activityType) {
    case 'quiz':
      return 'Bulk Export Quizzes';
    case 'poll':
      return 'Bulk Export Polls Participation';
    default:
      return '';
  }
}

export function getTipText(activityType: BulkExportActivityType) {
  switch (activityType) {
    case 'poll':
      return 'Only non anonymous polls can be exported';
    default:
      return '';
  }
}

export function getSectionTitle(activityType: BulkExportActivityType) {
  switch (activityType) {
    case 'quiz':
      return 'Select quizzes to export';
    case 'poll':
      return 'Select polls to export';
    default:
      return '';
  }
}

/**
 * Returns a color class name for a number between 0 and 100, returns empty string otherwise
 * @param percentage attendance percentage
 */
export function getColorClassForPercentage(percentage: number) {
  if (percentage >= 80) return 'table__cell-value--green';
  else if (percentage >= 60) return 'table__cell-value--orange';
  return 'table__cell-value--red';
}
